import { Button, Card } from "@dawa/ui";

export function ShortcutsOverlay({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;
  const items = [
    { combo: "g c", label: "Aller à Contenus" },
    { combo: "g n", label: "Créer un contenu" },
    { combo: "g d", label: "Aller au Dashboard" },
    { combo: "g p", label: "Aller aux Projets" },
    { combo: "g k", label: "Aller à Mots‑clés" },
    { combo: "g h", label: "Aller à l’Historique" },
    { combo: "g s", label: "Aller aux Paramètres" },
    { combo: "g b", label: "Aller à la Facturation" },
    { combo: "?", label: "Ouvrir l’aide raccourcis" },
    { combo: "Esc", label: "Fermer les panneaux/menus" },
  ];
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40 p-4" role="dialog" aria-modal="true" aria-label="Aide raccourcis clavier">
      <Card className="w-full max-w-lg space-y-3 p-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold">Raccourcis clavier</h3>
          <Button size="sm" variant="secondary" onClick={onClose} aria-label="Fermer">Fermer</Button>
        </div>
        <div className="grid grid-cols-1 gap-2">
          {items.map((it) => (
            <div key={it.combo} className="flex items-center justify-between rounded border px-2 py-1 text-sm">
              <span className="font-mono">{it.combo}</span>
              <span className="text-text">{it.label}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
